import React, { useEffect, useState } from "react";
import styles from "../../../styles/scope1/dashboard.module.css";
import { durationObj, monthSort } from "../../../utils/constant";
import LineChart from "../../../Components/GraphNCharts/LineChart";
import PieChart from "../../../Components/GraphNCharts/Pie";
import { Box, Typography, TextField, MenuItem } from "@mui/material";
import BarChart from "../../../Components/GraphNCharts/BarChart";
import GlobalChart from "../../../Components/GraphNCharts/GlobalChart";
import TableChart from "../../../Components/GraphNCharts/TableChart";
import EchartDoughnutChart from "../../../Components/GraphNCharts/EchartDoughnut";
import { get } from "../../../utils/api";
import CircleIcon from "@mui/icons-material/Circle";
import PeriodFilter from "../../../Components/Common/PeriodFilter";
import { fixedTons, formatNumberCommaSeparated } from "../../../utils/common";
import useAuthStore from "../../../store/ContextUser";
import { useUser } from "../../../context/AuthContext";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import Unauthorized from "../../../Components/Unauthorized/Unauthorized";
import Scope4Layout from "../../../Layout/Scope4Layout";
import Cards from "../../../Components/Common/Cards";
import { Bar } from "react-chartjs-2";
import styles1 from "../../../styles/scope3/Dashboard/purchaseGoods.module.css";

const Dashboard = () => {
  const currentDate = new Date();
  const { selectedCompany } = useAuthStore();
  const { user } = useUser();
  const isFacilityRoleUser = Boolean(user?.role?.facility || user?.facility);
  const currentYear = currentDate.getFullYear();
  const VINTAGE_YEAR_START = 2021;
  const VINTAGE_YEAR_END = 2026;
  const [month, setMonth] = useState("1M");
  const [tableData, setTableData] = useState();
  const [ghg, setGhg] = useState([]);
  const [emissionVehicleType, setEmissionVehicleType] = useState([]);
  const [stationaryEmission, setStationaryEmission] = useState([]);
  const [mobileEmissionTotal, setMobileEmissionTotal] = useState([]);
  const [mobileEmission, setMobileEmission] = useState([]);
  const [vehicleEmission, setVehicleEmission] = useState([]);
  const [fugitive, setFugitive] = useState([]);
  const [renewableAvoidance, setRenewableAvoidance] = useState([]);
  const [lowCarbonProductUse, setLowCarbonProductUse] = useState({
    highestContributionAvoidance: "",
    cards: [],
  });
  const [overviewData, setOverviewData] = useState({
    totalAvoidedEmission: 0,
    topAvoidedSource: "-",
    avoidanceIntensity: 0,
    percentageChange: "0",
    monthlyAvoidanceEmissionTrend: {
      data: [],
      total: 0,
      percentageChange: "0",
    },
  });
  const [carbonOffsettingCardData, setCarbonOffsettingCardData] = useState({
    totalCarbonSequestered: 0,
    annualEmissionOffSet: 0,
    highestSequestrationProject: {
      projectName: "-",
      carbonSequesteredAnnually: 0,
    },
  });
  const [carbonProduct, setCarbonProduct] = useState([]);
  const [stationaryCombustion, setStationaryCombustion] = useState({});
  const [mobileCombustion, setMobileCombustion] = useState({});
  const [fugitiveCombustion, setFugitiveCombustion] = useState({});
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [selectedOffsetType, setSelectedOffsetType] = useState("All");
  const [selectedFacility, setSelectedFacility] = useState([]);
  const [vintageYearGraphData, setVintageYearGraphData] = useState([]);
  const [carbonOffsettingData, setCarbonOffsettingData] = useState({
    typeBreakdown: [],
    totalEmission: 0,
    previousTotalEmission: 0,
    percentageChange: 0,
    verifiedCredits: 0,
    unverifiedCredits: 0,
    underReviewCredits: 0,
    internalCredits: 0,
  });

  useEffect(() => {
    fetchScope4Overview();
    fetchAvoidanceFromRenewable();
    fetchLowCarbonProductUse();
    fetchCarbonOffsettingCardData();
    // fetchStationaryEmission();
    // fetchMobileEmissionTotal();
    // fetchMobileEmission();
    // fetchEmissionByVehicle();
    // fetchVehicleEmission();
    // fetchFugitiveEmission();
    // fetchStationary();
    // fetchMobile();
    // fetchFugitive();
    // fetchGHGEmission();
  }, [fromDate, toDate, selectedFacility, selectedCompany]);

  useEffect(() => {
    fetchVintageYearGraph();
  }, [selectedFacility, selectedCompany]);

  useEffect(() => {
    fetchCarbonOffsetting();
  }, [fromDate, toDate, selectedFacility, selectedCompany]);

  const fetchVintageYearGraph = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/vintageYearGraph?year=${VINTAGE_YEAR_START}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      setVintageYearGraphData(res?.data?.offSetData || []);
    } catch (error) {
      console.error("Error fetching vintage year graph:", error);
      setVintageYearGraphData([]);
    }
  };

  const fetchCarbonOffsettingCardData = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/carbonOffSettingCardData?startYear=${fromDate.year}&startMonth=${
          fromDate.month
        }&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      console.log("fetchCarbonOffsettingCardData", res?.data);
      setCarbonOffsettingCardData({
        totalCarbonSequestered: res?.data?.totalCarbonSequestered || 0,
        annualEmissionOffSet: res?.data?.annualEmissionOffSet || 0,
        highestSequestrationProject: res?.data?.highestSequestrationProject || {
          projectName: "-",
          carbonSequesteredAnnually: 0,
        },
      });
    } catch (error) {
      console.error("Error fetching carbon offsetting card data:", error);
      setCarbonOffsettingCardData({
        totalCarbonSequestered: 0,
        annualEmissionOffSet: 0,
        highestSequestrationProject: {
          projectName: "-",
          carbonSequesteredAnnually: 0,
        },
      });
    }
  };

  const fetchCarbonOffsetting = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/carbonOffSetting?startYear=${fromDate.year}&startMonth=${fromDate.month}&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      console.log("fetchCarbonOffsetting", res?.data);
      const payload = res?.data || {};
      const distributeData = payload?.offSetDistributeTypeData || {};
      const rawTypeBreakdown = Array.isArray(distributeData?.data)
        ? distributeData.data
        : Array.isArray(payload?.offSetData)
          ? payload.offSetData
          : Array.isArray(payload?.offsetData)
            ? payload.offsetData
            : Array.isArray(payload?.projectTypeData)
              ? payload.projectTypeData
              : [];
      const verificationData = Array.isArray(payload?.verifyAndUnverifyCredi)
        ? payload.verifyAndUnverifyCredi
        : Array.isArray(payload?.verifyAndUnverifyCredit)
          ? payload.verifyAndUnverifyCredit
          : [];

      const typeBreakdown = rawTypeBreakdown
        .map((item) => ({
          label:
            item?.projectType ||
            item?.type ||
            item?.label ||
            item?.name ||
            item?.category ||
            "-",
          value: Number(
            item?.totalCreditsPurchased ??
              item?.value ??
              item?.totalEmission ??
              item?.emission ??
              item?.creditsPurchased ??
              item?.total ??
              0,
          ),
          color: item?.color,
          previousValue: Number(
            item?.previousValue ??
              item?.previousEmission ??
              item?.previousYearEmission ??
              0,
          ),
        }))
        .filter((item) => item?.label && Number.isFinite(item?.value));

      const typeTotal = typeBreakdown.reduce(
        (sum, item) => sum + Number(item?.value || 0),
        0,
      );

      const findByStatus = (status) =>
        verificationData.find(
          (item) =>
            String(item?.verificationStatus || "")
              .toLowerCase()
              .trim() === status,
        );
      const verifiedItem = findByStatus("verified");
      const unverifiedItem = findByStatus("unverified");
      const underReviewItem = findByStatus("under review");
      const internalItem = findByStatus("internal");

      setCarbonOffsettingData({
        typeBreakdown,
        totalEmission: Number(
          distributeData?.total ??
            payload?.totalEmission ??
            payload?.total ??
            typeTotal ??
            0,
        ),
        previousTotalEmission: Number(
          distributeData?.previousTotalEmission ??
            payload?.previousTotalEmission ??
            payload?.previousEmission ??
            0,
        ),
        percentageChange:
          distributeData?.percentageChange ?? payload?.percentageChange ?? 0,
        verifiedCredits: Number(
          verifiedItem?.totalCarbonSequestered ??
            payload?.verifiedCredits ??
            payload?.verified ??
            payload?.verifiedPercentage ??
            0,
        ),
        unverifiedCredits: Number(
          unverifiedItem?.totalCarbonSequestered ??
            payload?.unverifiedCredits ??
            payload?.unverified ??
            payload?.unverifiedPercentage ??
            0,
        ),
        underReviewCredits: Number(
          underReviewItem?.totalCarbonSequestered ?? 0,
        ),
        internalCredits: Number(internalItem?.totalCarbonSequestered ?? 0),
      });
    } catch (error) {
      console.error("Error fetching carbon offsetting:", error);
      setCarbonOffsettingData({
        typeBreakdown: [],
        totalEmission: 0,
        previousTotalEmission: 0,
        percentageChange: 0,
        verifiedCredits: 0,
        unverifiedCredits: 0,
        underReviewCredits: 0,
        internalCredits: 0,
      });
    }
  };

  const fetchLowCarbonProductUse = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/lowCarbonProductUse?startYear=${fromDate.year}&startMonth=${
          fromDate.month
        }&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      console.log("fetchLowCarbonProductUse", res?.data);
      const highestContribution = res?.data?.highestContributionAvoidance || {};
      // const unitsSold = res?.data?.noOfLowCarbonProductUnitsoldData || {};
      const emissionAvoided = res?.data?.emissionAvoidedDueToProductData || {};
      const perUnitAvoidance =
        res?.data?.avoidancePerUnitOfProductSoldData || {};
      const productSoldMonthlyData = res?.data?.productSoldMonthlyData || {};
      const productSoldMonthlySeries = Array.isArray(
        productSoldMonthlyData?.data,
      )
        ? productSoldMonthlyData.data
        : [];
      const productSoldMonthlyTotal = productSoldMonthlySeries.reduce(
        (sum, row) => sum + Number(row?.totalQuantitySold || 0),
        0,
      );
      const unitsSold = res?.data?.noOfLowCarbonProductUnitsoldData || {};

      const unitsSoldRows = Array.isArray(unitsSold?.data)
        ? unitsSold.data
        : [];

      // Get unique years
      const unitsSoldYears = [
        ...new Set(
          unitsSoldRows
            .map((item) => Number(item?.year))
            .filter(Number.isFinite),
        ),
      ].sort((a, b) => a - b);

      // Get unique units
      const unitsSoldTypes = [
        ...new Set(unitsSoldRows.map((item) => item?.unit).filter(Boolean)),
      ];
      const chartColors = [
        "#0051B7", // blue
        "#4CAF50", // green
        "#FF9800", // orange
        // "#9C27B0", // purple
        // "#F44336", // red
        // "#00BCD4", // cyan
      ];

      // Create one line for every unit
      const unitsSoldDatasets = unitsSoldTypes.map((unit, index) => ({
        label: unit,

        data: unitsSoldYears.map((year) => {
          const matchingRows = unitsSoldRows.filter(
            (item) => Number(item?.year) === year && item?.unit === unit,
          );

          if (!matchingRows.length) {
            return null;
          }

          return matchingRows.reduce(
            (sum, item) => sum + (Number(item?.value) || 0),
            0,
          );
        }),

        backgroundColor: chartColors[index % chartColors.length],
        borderColor: chartColors[index % chartColors.length],
        borderWidth: 2,
      }));

      setLowCarbonProductUse({
        highestContributionAvoidance: highestContribution || "-",
        cards: [
          {
            title: "No. of low-carbon product units sold YTD",
            value: unitsSold?.total || 0,
            percentageChange: unitsSold?.percentageChange,
            // labels: (unitsSold?.data || []).map((el) => String(el?.year)),
            labels: unitsSoldYears.map(String),
            dataSet: unitsSoldDatasets,

            // dataSet: [
            //   {
            //     label: "Units Sold",
            //     data: (unitsSold?.data || []).map((el) => el?.value || 0),
            //     borderColor: "#0051B7",
            //     backgroundColor: "#0051B7",
            //     tension: 0.4,
            //     fill: true,
            //     pointBorderColor: "#fff",
            //     pointRadius: 0,
            //   },
            // ],
          },
          {
            title: "Emissions avoided due to product substitution (tCO₂e)",
            value: emissionAvoided?.total || 0,
            percentageChange: emissionAvoided?.percentageChange,
            labels:
              selectedYearLabels.length > 0
                ? selectedYearLabels
                : (emissionAvoided?.data || []).map((el) =>
                    String(el?.year ?? ""),
                  ),
            dataSet: [
              {
                label: "Emissions Avoided",
                data:
                  selectedYearLabels.length > 0
                    ? selectedYearLabels.map((y) => {
                        const rows = Array.isArray(emissionAvoided?.data)
                          ? emissionAvoided.data
                          : [];
                        const hit = rows.find(
                          (row) => String(row?.year) === String(y),
                        );
                        if (hit) return hit?.totalEmission ?? hit?.value ?? 0;

                        // Fallback: if API doesn't provide year and only one point,
                        // place it on the selected end-year to avoid shifting to first year.
                        const fallbackYear = String(
                          toDate?.year ?? currentYear,
                        );
                        const onlyRow = rows.length === 1 ? rows[0] : null;
                        if (
                          onlyRow &&
                          (onlyRow?.year === undefined ||
                            onlyRow?.year === null) &&
                          String(y) === fallbackYear
                        ) {
                          return onlyRow?.totalEmission ?? onlyRow?.value ?? 0;
                        }
                        return 0;
                      })
                    : (emissionAvoided?.data || []).map(
                        (el) => el?.totalEmission ?? el?.value ?? 0,
                      ),
                borderColor: "#0051B7",
                backgroundColor: "#0051B7",
                tension: 0.4,
                fill: true,
                pointBorderColor: "#fff",
                pointRadius: 0,
              },
            ],
          },
          {
            title: "Avoidance per unit of product sold (tCO₂e/unit)",
            value:
              perUnitAvoidance?.total ??
              productSoldMonthlyData?.total ??
              productSoldMonthlyTotal,
            percentageChange:
              perUnitAvoidance?.percentageChange ??
              productSoldMonthlyData?.percentageChange,
            labels: productSoldMonthlySeries.map((el) => {
              const month = Number(el?.month);
              const year = Number(el?.year);
              if (month >= 1 && month <= 12 && Number.isFinite(year)) {
                return `${monthSort[month - 1]} ${year}`;
              }
              return "-";
            }),
            dataSet: [
              {
                label: "Per Unit Avoidance",
                data: productSoldMonthlySeries.map(
                  (el) => el?.totalQuantitySold ?? 0,
                ),
                borderColor: "#0051B7",
                backgroundColor: "#0051B7",
                tension: 0.4,
                fill: true,
                pointBorderColor: "#fff",
                pointRadius: 0,
              },
            ],
          },
        ],
      });
    } catch (error) {
      console.error("Error fetching low carbon product use: =>", error);
      setLowCarbonProductUse({
        highestContributionAvoidance: 0,
        cards: [],
      });
    }
  };

  const fetchAvoidanceFromRenewable = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/avoidanceFromRenewable?startYear=${fromDate.year}&startMonth=${
          fromDate.month
        }&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      console.log("fetchAvoidanceFromRenewable", res?.data);
      const energyData = res?.data?.totalEnergyExportData || {};
      const emissionData = res?.data?.totalEmissionData || {};
      const facilityData = res?.data?.emissionByFacilityData || {};
      const gridFactorData =
        res?.data?.effectiveGridEmissionFactorData ??
        res?.data?.effectiveGridFactorData ??
        res?.data?.gridEmissionFactorData ??
        res?.data?.gridFactorData ??
        {};

      setRenewableAvoidance([
        {
          title: "Total energy exported YTD (kWh):",
          value: energyData?.total || 0,
          percentageChange: energyData?.percentageChange,
          labels: (energyData?.data || []).map((el) => String(el?.year)),
          dataSet: [
            {
              label: "Energy Export",
              data: (energyData?.data || []).map((el) => el?.value || 0),
              borderColor: "#0051B7",
              backgroundColor: "#0051B7",
              tension: 0.4,
              fill: true,
              pointBorderColor: "#fff",
              pointRadius: 0,
            },
          ],
        },
        {
          title: "Avoided emissions from export (tCO₂e) :",
          value: emissionData?.total || 0,
          percentageChange: emissionData?.percentageChange,
          labels: (emissionData?.data || []).map((el) => String(el?.year)),
          dataSet: [
            {
              label: "Avoided Emissions",
              data: (emissionData?.data || []).map((el) => el?.value || 0),
              borderColor: "#0051B7",
              backgroundColor: "#0051B7",
              tension: 0.4,
              fill: true,
              pointBorderColor: "#fff",
              pointRadius: 0,
            },
          ],
        },
        {
          title: "Effective grid emission factor used:",
          value: gridFactorData?.total || 0,
          percentageChange: gridFactorData?.percentageChange,
          labels: (gridFactorData?.data || []).map((el) =>
            String(el?.year ?? el?.period ?? "-"),
          ),
          dataSet: [
            {
              label: "Grid Emission Factor",
              data: (gridFactorData?.data || []).map(
                (el) => el?.value ?? el?.totalEmission ?? 0,
              ),
              borderColor: "#0051B7",
              backgroundColor: "#0051B7",
              tension: 0.4,
              fill: true,
              pointBorderColor: "#fff",
              pointRadius: 0,
            },
          ],
        },
        {
          title: "Current and Previous Year Emissions by Facility:",
          value: facilityData?.total || 0,
          percentageChange: facilityData?.percentageChange,
          labels: (facilityData?.data || []).map(
            (el) => el?.facilityName || "-",
          ),
          dataSet: [
            {
              label: "Facility Emissions",
              data: (facilityData?.data || []).map(
                (el) => el?.totalEmission || 0,
              ),
              borderColor: "#0051B7",
              backgroundColor: "#0051B7",
              tension: 0.4,
              fill: true,
              pointBorderColor: "#fff",
              pointRadius: 0,
            },
          ],
        },
      ]);
    } catch (error) {
      console.error("Error fetching avoidance from renewable:", error);
      setRenewableAvoidance([]);
    }
  };

  const fetchScope4Overview = async () => {
    try {
      const res = await get(
        `/dashboard/scope4/overview?startYear=${fromDate.year}&startMonth=${
          fromDate.month
        }&endYear=${toDate.year}&endMonth=${toDate.month}&facilities=${selectedFacility.join(
          ",",
        )}&companyId=${selectedCompany?._id}`,
      );
      console.log("fetchScope4Overview", res?.data);
      const monthlyAvoidanceEmissionTrend =
        res?.data?.monthlyAvoidanceEmissionTrenEmission ||
        res?.data?.monthlyAvoidanceEmissionTrendEmission ||
        res?.data?.monthlyAvoidanceEmissionTrend ||
        {};
      setOverviewData({
        totalAvoidedEmission: res?.data?.totalAvoidedEmission ?? 0,
        topAvoidedSource: res?.data?.topAvoidedSource || "-",
        avoidanceIntensity: res?.data?.avoidanceIntensity ?? 0,
        percentageChange: res?.data?.percentageChange ?? "0",
        monthlyAvoidanceEmissionTrend: {
          data: Array.isArray(monthlyAvoidanceEmissionTrend?.data)
            ? monthlyAvoidanceEmissionTrend.data
            : [],
          total: monthlyAvoidanceEmissionTrend?.total ?? 0,
          percentageChange:
            monthlyAvoidanceEmissionTrend?.percentageChange ?? "0",
        },
      });
    } catch (error) {
      console.error("Error fetching scope4 overview:", error);
      setOverviewData({
        totalAvoidedEmission: 0,
        topAvoidedSource: "-",
        avoidanceIntensity: 0,
        percentageChange: "0",
        monthlyAvoidanceEmissionTrend: {
          data: [],
          total: 0,
          percentageChange: "0",
        },
      });
    }
  };

  const fetchGlobalData = async () => {
    try {
      let response = await get(
        `dashboard/globalEmission/scope1/totalEmission?timeFrame=${month}&companyId=${selectedCompany?._id}`,
      );
      setTableData(response?.data?.data);
      console.log("first45", response?.data?.data);
    } catch (error) {}
  };

  useEffect(() => {
    fetchGlobalData();
  }, [month, selectedCompany]);

  const generateYearList = (startYear = 2013) => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }
    return years;
  };
  const yearList = generateYearList(2013);

  const PIE_CHART_COLORS = [
    "#FFBB33",
    "#0051B7",
    "#9200B7",
    "#FF4444",
    "#3CD715",
  ];

  const stationaryEmissionLabels = (
    carbonOffsettingData?.typeBreakdown || []
  ).map((item, index) => ({
    label: item?.label || "-",
    value: Number(item?.value || 0),
    previousValue: Number(item?.previousValue || 0),
    color: item?.color || PIE_CHART_COLORS[index % PIE_CHART_COLORS.length],
  }));

  const stationaryPieDataPoints = stationaryEmissionLabels.map((el) =>
    Number(el?.value) > 0 ? Number(el?.value) : 0.0001,
  );
  useEffect(() => {
    if (
      selectedOffsetType !== "All" &&
      !stationaryEmissionLabels.some(
        (item) => item.label === selectedOffsetType,
      )
    ) {
      setSelectedOffsetType("All");
    }
  }, [selectedOffsetType, stationaryEmissionLabels]);

  const filteredStationaryEmissionLabels =
    selectedOffsetType === "All"
      ? stationaryEmissionLabels
      : stationaryEmissionLabels.filter(
          (el) => el.label === selectedOffsetType,
        );
  const filteredStationaryPieDataPoints = filteredStationaryEmissionLabels.map(
    (el) => (Number(el?.value) > 0 ? Number(el?.value) : 0.0001),
  );
  const selectedOffsetTotal =
    selectedOffsetType === "All"
      ? fixedTons(carbonOffsettingData?.totalEmission ?? 0)
      : fixedTons(filteredStationaryEmissionLabels?.[0]?.value ?? 0);
  const toNumberSafe = (value) => {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
  };
  const computeYoY = (current, previous) => {
    const curr = toNumberSafe(current);
    const prev = toNumberSafe(previous);
    if (!Number.isFinite(prev) || prev <= 0) {
      return { percent: 0, arrow: "→", color: "#6b7280" };
    }
    const percent = ((curr - prev) / prev) * 100;
    if (percent > 0) return { percent, arrow: "↗", color: "#08b451" };
    if (percent < 0) return { percent, arrow: "↘", color: "#ef4444" };
    return { percent: 0, arrow: "→", color: "#6b7280" };
  };
  const formatYoYText = ({ percent, arrow }) => {
    const sign = percent > 0 ? "+" : "";
    const arrowText = arrow ? ` ${arrow}` : "";
    return `(${sign}${percent.toFixed(2)}% YOY${arrowText})`;
  };
  const yoyFromApiPercentageChange = (raw) => {
    if (raw === undefined || raw === null || raw === "") return null;
    const pct = Number(String(raw).trim().replace(/%/g, ""));
    if (!Number.isFinite(pct)) return null;
    if (pct > 0) return { percent: pct, arrow: "↗", color: "#08b451" };
    if (pct < 0) return { percent: pct, arrow: "↘", color: "#ef4444" };
    return { percent: 0, arrow: "", color: "#6b7280" };
  };
  const getFugitiveYoY = (chartItem = {}) => {
    const apiYoY = yoyFromApiPercentageChange(chartItem?.percentageChange);
    if (apiYoY !== null) return apiYoY;
    return { percent: 0, arrow: "", color: "#6b7280" };
  };
  const getFugitiveUnit = (chartItem = {}) => {
    const title = String(chartItem?.title || "").toLowerCase();
    if (title.includes("no. of low-carbon product units sold ytd")) {
      return " Units";
    }
    if (title.includes("emissions avoided due to product substitution")) {
      return " tCO₂e";
    }
    if (title.includes("emissions by facility")) return " tCO₂e";
    if (title.includes("effective grid emission factor used")) return " tCO₂e";
    if (title.includes("total energy exported ytd")) return " kWh";
    return " tCO₂e";
  };
  const getFugitiveYAxisTitle = (chartItem = {}) => {
    const title = String(chartItem?.title || "").toLowerCase();
    if (title.includes("no. of low-carbon product units sold ytd")) {
      return "UNITS";
    }
    if (title.includes("emissions avoided due to product substitution")) {
      return "tCO₂e";
    }
    return getFugitiveUnit(chartItem);
  };
  const getOffsetPreviousValue = () => {
    if (selectedOffsetType === "All") {
      return toNumberSafe(carbonOffsettingData?.previousTotalEmission ?? 0);
    }
    return toNumberSafe(
      filteredStationaryEmissionLabels?.[0]?.previousValue ?? 0,
    );
  };
  const selectedOffsetYoY =
    yoyFromApiPercentageChange(carbonOffsettingData?.percentageChange) ??
    computeYoY(selectedOffsetTotal, getOffsetPreviousValue());

  // let bannerData = [
  //   {
  //     title: "Total avoided emissions (tCO₂e)",
  //     description: formatNumberCommaSeparated(
  //       fixedTons(overviewData?.totalAvoidedEmission || 0)
  //     ),
  //   },
  //   {
  //     title: "Top avoidance source (tCO₂e)",
  //     description: overviewData?.topAvoidedSource || "-",
  //   },
  //   {
  //     title: "Avoidance intensity",
  //     description: `${overviewData?.avoidanceIntensity ?? 0}`,
  //   },
  //   {
  //     title: "% Change in Avoidance",
  //     description: `${Number(overviewData?.percentageChange || 0).toFixed(2)}%`,
  //   },
  // ];

  const monthlyAvoidanceTrendRows = Array.isArray(
    overviewData?.monthlyAvoidanceEmissionTrend?.data,
  )
    ? overviewData.monthlyAvoidanceEmissionTrend.data
    : [];
  const hasMultipleMonthlyTrendYears =
    new Set(monthlyAvoidanceTrendRows.map((row) => Number(row?.year) || ""))
      .size > 1;
  const monthlyAvoidanceTrendTotal = Number(
    overviewData?.monthlyAvoidanceEmissionTrend?.total || 0,
  );
  const monthlyAvoidanceTrendYoY = yoyFromApiPercentageChange(
    overviewData?.monthlyAvoidanceEmissionTrend?.percentageChange,
  ) ?? { percent: 0, arrow: "", color: "#6b7280" };
  const monthlyAvoidanceTrendData = {
    labels: monthlyAvoidanceTrendRows.map((row) => {
      const monthIndex = Number(row?.month) - 1;
      const monthLabel = monthSort[monthIndex] || `M${row?.month || ""}`;
      const year = Number(row?.year) || "";
      return hasMultipleMonthlyTrendYears && year
        ? `${monthLabel} ${year}`
        : monthLabel;
    }),
    datasets: [
      {
        label: "Avoided emissions",
        data: monthlyAvoidanceTrendRows.map((row) =>
          Number(
            row?.totalQuantitySold ?? row?.totalEmission ?? row?.value ?? 0,
          ),
        ),
        backgroundColor: "#0051B7",
        borderColor: "#0051B7",
        borderWidth: 0,
      },
    ],
  };

  let bannerData1 = [
    {
      title: "Product with highest contribution to avoidance",
      description: lowCarbonProductUse?.highestContributionAvoidance || "-",
      height: "7rem",
    },
  ];

  let bannerData2 = [
    {
      title: "Total Carbon Sequestered",
      description:
        formatNumberCommaSeparated(
          fixedTons(carbonOffsettingCardData?.totalCarbonSequestered || 0),
        ) + " tCO₂e",
    },
    {
      title: "% of Annual Emissions Offset",
      description: `${formatNumberCommaSeparated(
        fixedTons(carbonOffsettingCardData?.annualEmissionOffSet || 0),
      )}  %`,
    },
    {
      title: "Project with Highest Sequestration",
      description: `${
        carbonOffsettingCardData?.highestSequestrationProject?.projectName || ""
      } | ${formatNumberCommaSeparated(
        fixedTons(
          carbonOffsettingCardData?.highestSequestrationProject
            ?.carbonSequesteredAnnually || 0,
        ),
      )} tCO₂e`,
    },
  ];

  const renewableAvoidanceCards =
    renewableAvoidance?.length > 0 ? renewableAvoidance : fugitive;
  const lowCarbonProductCards =
    lowCarbonProductUse?.cards?.length > 0
      ? lowCarbonProductUse.cards
      : fugitive;

  const verificationStatuses = [
    { key: "verifiedCredits", label: "Verified", color: "#007bff" },
    { key: "unverifiedCredits", label: "Unverified", color: "#f57c00" },
    { key: "underReviewCredits", label: "Under Review", color: "#9c27b0" },
    { key: "internalCredits", label: "Internal", color: "#4caf50" },
  ];

  const data = {
    labels: verificationStatuses.map((s) => s.label),
    datasets: [
      {
        label: "Credits",
        data: verificationStatuses.map((s) => {
          const val = Number(carbonOffsettingData?.[s.key] || 0);
          return val === 0 ? null : val;
        }),
        backgroundColor: verificationStatuses.map((s) => s.color),
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: { display: false },
      title: {
        display: true,
        // text: "Verified vs Unverified Credits",
        align: "start",
        font: {
          size: 14,
        },
        color: "#555",
        padding: {
          bottom: 20,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: (value) => value,
        },
        title: {
          display: true,
          text: "%",
          color: "#555",
          font: {
            size: 12,
          },
        },
        grid: {
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const vintageYearLabels = Array.from(
    { length: VINTAGE_YEAR_END - VINTAGE_YEAR_START + 1 },
    (_, index) => String(VINTAGE_YEAR_START + index),
  );

  const creditsPurchasedByVintageYear = {};
  (Array.isArray(vintageYearGraphData) ? vintageYearGraphData : []).forEach(
    (row) => {
      const vy = row?.vintageYear;
      if (vy == null || vy === "") return;
      const yKey = Number(vy);
      if (!Number.isFinite(yKey)) return;
      const add = Number(row?.creditsPurchased);
      const n = Number.isFinite(add) ? add : 0;
      creditsPurchasedByVintageYear[yKey] =
        (creditsPurchasedByVintageYear[yKey] ?? 0) + n;
    },
  );

  const vintageYearHasApiPoint = vintageYearLabels.map((label) =>
    Object.prototype.hasOwnProperty.call(
      creditsPurchasedByVintageYear,
      Number(label),
    ),
  );

  const vintageYearData = vintageYearLabels.map((label, idx) =>
    vintageYearHasApiPoint[idx]
      ? Number(creditsPurchasedByVintageYear[Number(label)]) === 0
        ? null
        : creditsPurchasedByVintageYear[Number(label)]
      : null,
  );

  const data1 = {
    labels: vintageYearLabels,
    datasets: [
      {
        label: "Credits purchased",
        data: vintageYearData,
        backgroundColor: "#FF4D4D",
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };

  const options1 = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
      title: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (items) =>
            items?.[0]?.label != null ? `Vintage ${items[0].label}` : "",
          label: (ctx) => {
            const y = Number(ctx.label);
            if (
              !Object.prototype.hasOwnProperty.call(
                creditsPurchasedByVintageYear,
                y,
              )
            ) {
              return "";
            }
            return `Credits purchased: ${creditsPurchasedByVintageYear[y]}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "tCO2e",
          color: "#555",
          font: {
            size: 12,
          },
        },
        ticks: {
          callback: (value) => {
            if (value >= 1000000) return `${value / 1000000}M`;
            if (value >= 1000) return `${value / 1000}k`;
            return value;
          },
        },
        grid: { drawBorder: false },
      },
      x: {
        grid: { display: false },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 0,
          callback(_value, index) {
            const yearStr = vintageYearLabels[index];
            if (!yearStr) return "";
            return yearStr;
          },
        },
      },
    },
  };

  const selectedYearLabels =
    fromDate?.year && toDate?.year
      ? Array.from(
          {
            length: Math.max(
              0,
              Number(toDate.year) - Number(fromDate.year) + 1,
            ),
          },
          (_, i) => String(Number(fromDate.year) + i),
        )
      : [];

  const buildMonthYearLabels = (start, end) => {
    if (!start?.year || !start?.month || !end?.year || !end?.month) return [];
    const labels = [];
    let year = Number(start.year);
    let month = Number(start.month);
    const endYear = Number(end.year);
    const endMonth = Number(end.month);

    while (year < endYear || (year === endYear && month <= endMonth)) {
      labels.push(`${monthSort[month - 1]} ${year}`);
      month += 1;
      if (month > 12) {
        month = 1;
        year += 1;
      }
    }
    return labels;
  };

  const selectedInsightData =
    lowCarbonProductCards?.find((item) =>
      String(item?.title || "")
        .toLowerCase()
        .includes("avoidance per unit of product sold"),
    ) || {};
  const insightMonthYearLabels = buildMonthYearLabels(fromDate, toDate);
  const insightSeriesDataRaw = Array.isArray(
    selectedInsightData?.dataSet?.[0]?.data,
  )
    ? selectedInsightData.dataSet[0].data
    : [];
  const insightSeriesData = insightMonthYearLabels.map((_, idx) =>
    idx < insightSeriesDataRaw.length ? insightSeriesDataRaw[idx] : 0,
  );
  const insightSeriesDataForChart = insightSeriesData.map((value) =>
    Number(value) === 0 ? null : value,
  );
  const insightYoY = getFugitiveYoY(selectedInsightData);
  const insightChartData = {
    labels: insightMonthYearLabels,
    datasets: [
      {
        label: selectedInsightData?.dataSet?.[0]?.label || "UNITS",
        data: insightSeriesDataForChart,
        backgroundColor: "#0051B7",
        borderRadius: 4,
        barThickness: insightMonthYearLabels.length === 1 ? 30 : 16,
        maxBarThickness: insightMonthYearLabels.length === 1 ? 30 : 24,
      },
    ],
  };
  const insightChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      datalabels: { display: false },
      title: { display: false },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "tCO2e",
          color: "#555",
          font: {
            size: 12,
          },
        },
        title: {
          display: true,
          text: getFugitiveYAxisTitle(selectedInsightData),
          color: "#555",
          font: { size: 12 },
        },
        grid: { drawBorder: false },
      },
      x: {
        grid: { display: false },
      },
    },
  };

  const getBarChartLabels = (chartItem = {}) => {
    const currentLabels = Array.isArray(chartItem?.labels)
      ? chartItem.labels
      : [];
    // Only override when the chart is year-based, otherwise keep original labels
    const isYearLabels =
      currentLabels.length > 0 &&
      currentLabels.every((l) => /^\d{4}$/.test(String(l).trim()));
    return selectedYearLabels.length > 0 && isYearLabels
      ? selectedYearLabels
      : currentLabels;
  };

  const getBarChartDatasets = (chartItem = {}) => {
    const datasets = Array.isArray(chartItem?.dataSet) ? chartItem.dataSet : [];
    const currentLabels = Array.isArray(chartItem?.labels)
      ? chartItem.labels
      : [];
    const isYearLabels =
      currentLabels.length > 0 &&
      currentLabels.every((l) => /^\d{4}$/.test(String(l).trim()));
    if (selectedYearLabels.length === 0 || !isYearLabels) return datasets;

    return datasets.map((series) => {
      const rawData = Array.isArray(series?.data) ? series.data : [];
      // Align data by actual year label so values don't shift
      const yearToValue =
        rawData.length === currentLabels.length
          ? currentLabels.reduce((map, label, idx) => {
              map[String(label).trim()] = rawData[idx];
              return map;
            }, {})
          : null;

      const adjustedData = selectedYearLabels.map((year, idx) => {
        const yearKey = String(year).trim();
        const value = yearToValue
          ? (yearToValue[yearKey] ?? 0)
          : idx < rawData.length
            ? rawData[idx]
            : 0;
        return Number(value) === 0 ? null : value;
      });
      return {
        ...series,
        data: adjustedData,
        ...(selectedYearLabels.length === 1
          ? {
              barThickness: 30,
              maxBarThickness: 30,
            }
          : {}),
      };
    });
  };

  return (
    <MainDashboardLayout sidebar={<Scope4Layout />}>
      <Unauthorized requiredModule="Environment | Scope 4 | Carbon Offsetting">
        <div>
          <div className={styles.heading_container}>
            <p className={styles.heading}>Scope 4</p>
            <PeriodFilter
              {...{
                fromDate,
                setFromDate,
                toDate,
                setToDate,
                yearList,
                setSelectedFacility,
                selectedFacility,
              }}
            />
          </div>

          {/* <Cards
            data={bannerData}
            title={"Overview"}
            subtitle={"Carbon Avoidance"}
            singleRow
         
          /> */}
          <p
            style={{
              fontWeight: "700",
              fontSize: "22px",
              lineHeight: "150%",
              color: "#001632",
              fontFamily: "Inter",
              textDecoration: "underline",
              marginTop: "1rem",
              marginBottom: "1.5rem",
            }}
          >
            Overview
          </p>

          <p
            style={{
              fontWeight: "700",
              fontSize: "22px",
              lineHeight: "150%",
              color: "#001632",
              fontFamily: "Inter",
              textDecoration: "underline",
              marginTop: "1.3rem",
              marginBottom: "1rem",
            }}
          >
            Carbon Avoidance
          </p>

          <div className={styles1.emission_container}>
            <div className={styles1.card_container}>
              <p className={styles1.graph_heading}>
                Total avoided emissions (tCO₂e)
              </p>
              <p className={styles1.card_value} style={{ marginTop: "2rem" }}>
                {formatNumberCommaSeparated(
                  fixedTons(overviewData?.totalAvoidedEmission || 0),
                )}
              </p>
            </div>

            <div className={styles1.card_container}>
              <p className={styles1.graph_heading}>
                Top avoidance source by emission (tCO₂e)
              </p>
              <p className={styles1.card_value} style={{ marginTop: "2rem" }}>
                {overviewData?.topAvoidedSource || "-"}
              </p>
            </div>
          </div>

          <div className={styles.monthlyAvoidanceTrendCard}>
            <p className={styles.card_subheading}>
              Monthly avoided emission trend
            </p>
            <div className={styles.monthlyAvoidanceTrendHeader}>
              <span
                className={styles.emission_heading_span}
                style={{ marginLeft: 0 }}
              >
                {`${formatNumberCommaSeparated(
                  fixedTons(monthlyAvoidanceTrendTotal),
                )}`}
              </span>
              <span
                className={styles.trend_up}
                style={{ color: monthlyAvoidanceTrendYoY.color }}
              >
                {formatYoYText(monthlyAvoidanceTrendYoY)}
              </span>
            </div>
            <BarChart
              labels={monthlyAvoidanceTrendData.labels}
              datasets={monthlyAvoidanceTrendData.datasets}
              yAxisTitle="tCO₂e"
              customHeight="260px"
              ellipsis={false}
            />
          </div>

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline", margin: "1.5rem 0" }}
          >
            1. Avoidance from Renewable Energy Export
          </p>
          <div className={styles.chart_grid_full_width}>
            <div className={styles.chart_grid_two_cols}>
              {renewableAvoidanceCards
                ?.filter((el) => {
                  const title = String(el?.title || "").toLowerCase();
                  if (title.includes("effective grid emission factor used"))
                    return false;
                  if (
                    isFacilityRoleUser &&
                    title.includes("emissions by facility")
                  )
                    return false;
                  return true;
                })
                .map((el, index) => (
                  <div key={index} className={styles.diversity_container}>
                    {(() => {
                      const yoy = getFugitiveYoY(el);
                      const titleLower = String(el?.title || "").toLowerCase();
                      const point1CardTitle =
                        index === 0
                          ? "Total energy exported YTD (kWh)"
                          : index === 1
                            ? "Avoided emissions from export (tCO₂e)"
                            : el?.title;
                      const point1CardUnit =
                        index === 0
                          ? " kWh"
                          : index === 1
                            ? " tCO₂e"
                            : titleLower.includes(
                                  "effective grid emission factor used",
                                )
                              ? " tCO₂e"
                              : titleLower.includes("emissions by facility")
                                ? " tCO₂e"
                                : "";
                      return (
                        <>
                          <p className={styles.emission_heading}>
                            {point1CardTitle}
                          </p>
                          <div className={styles.emission_value_row}>
                            <span className={styles.emission_heading_span}>
                              {`${formatNumberCommaSeparated(
                                fixedTons(el?.value ?? 0),
                              )}${point1CardUnit}`}
                            </span>
                            <span
                              className={styles.trend_up}
                              style={{ color: yoy.color }}
                            >
                              {formatYoYText(yoy)}
                            </span>
                          </div>
                        </>
                      );
                    })()}
                    <BarChart
                      datasets={getBarChartDatasets(el)}
                      labels={getBarChartLabels(el)}
                      yAxisTitle={
                        index === 0
                          ? " kWh"
                          : index === 1
                            ? "tCO₂e"
                            : String(el?.title || "")
                                  .toLowerCase()
                                  .includes(
                                    "effective grid emission factor used",
                                  )
                              ? ""
                              : String(el?.title || "")
                                    .toLowerCase()
                                    .includes("emissions by facility")
                                ? "tCO₂e"
                                : el?.dataSet?.[0]?.label || "Quantity"
                      }
                      customHeight={"375px"}
                      ellipsis={true}
                    />
                  </div>
                ))}
            </div>
          </div>

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline" }}
          >
            2. Low-Carbon Product Use
          </p>
          <Cards
            data={bannerData1}
            title={""}
            width="49%"
            // onFilterChange={handlePeriodChange}
            // {...{
            //   setSelectedMonth,
            //   setSelectedYear,
            //   selectedMonth,
            //   selectedYear,
            // }}
          />
          <div
            className={styles.chart_grid_full_width}
            style={{ marginTop: "1rem" }}
          >
            <div className={styles.chart_grid_two_cols}>
              {lowCarbonProductCards
                ?.filter((el) => {
                  const t = String(el?.title || "").toLowerCase();
                  return (
                    t.includes("no. of low-carbon product units sold ytd") ||
                    t.includes("emissions avoided due to product substitution")
                  );
                })
                .map((el, index) => {
                  const chartDataArr = Array.isArray(el?.dataSet?.[0]?.data)
                    ? el.dataSet[0].data
                    : [];
                  const hasChartData =
                    chartDataArr.length > 0 &&
                    chartDataArr.some((v) => Number(v) !== 0);
                  const yoy = getFugitiveYoY(el);
                  const unit = getFugitiveUnit(el);
                  return (
                    <div key={index} className={styles.diversity_container}>
                      <p className={styles.emission_heading}>{el?.title}</p>
                      <div className={styles.emission_value_row}>
                        <span className={styles.emission_heading_span}>
                          {`${formatNumberCommaSeparated(
                            fixedTons(el?.value ?? 0),
                          )} ${unit}`}
                        </span>
                        <span
                          className={styles.trend_up}
                          style={{ color: yoy.color }}
                        >
                          {formatYoYText(yoy)}
                        </span>
                      </div>
                      {hasChartData ? (
                        <BarChart
                          datasets={getBarChartDatasets(el)}
                          labels={getBarChartLabels(el)}
                          yAxisTitle={getFugitiveYAxisTitle(el)}
                          customHeight={"375px"}
                          ellipsis={true}
                        />
                      ) : (
                        <Box
                          sx={{
                            height: "250px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Typography
                            sx={{
                              textAlign: "center",
                              color: "#d3d3d3",
                              fontWeight: "bold",
                              fontFamily: "inter",
                              fontSize: "24px",
                            }}
                          >
                            No Data Found
                          </Typography>
                        </Box>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>

          <div
            style={{
              background: "#fcfcfc",
              borderRadius: "12px",
              padding: "1.5rem",
              boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
              marginTop: "1.2rem",
              marginBottom: "1.2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "1rem",
                marginBottom: "1rem",
              }}
            >
              <div>
                <p className={styles.emission_heading} style={{ margin: 0 }}>
                  Avoidance per unit of product sold (tCO₂e/unit)
                </p>
                <div className={styles.emission_value_row}>
                  <span className={styles.emission_heading_span}>
                    {`${formatNumberCommaSeparated(
                      fixedTons(selectedInsightData?.value ?? 0),
                    )}`}
                  </span>
                  <span
                    className={styles.trend_up}
                    style={{ color: insightYoY.color }}
                  >
                    {formatYoYText(insightYoY)}
                  </span>
                </div>
              </div>
            </div>

            <div style={{ height: "320px" }}>
              <Bar data={insightChartData} options={insightChartOptions} />
            </div>
          </div>

          <p
            className={styles.card_heading}
            style={{ textDecoration: "underline" }}
          >
            3. Carbon Offsetting:
          </p>
          <Cards
            data={bannerData2}
            title={""}
            // onFilterChange={handlePeriodChange}
            // {...{
            //   setSelectedMonth,
            //   setSelectedYear,
            //   selectedMonth,
            //   selectedYear,
            // }}
          />

          <div
            className={styles.chart_grid_two_cols}
            style={{ marginTop: "2rem", marginBottom: "1.2rem" }}
          >
            <div
              className={styles.doughnut_container}
              style={{ width: "100%", padding: "1.5rem" }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  flexWrap: "wrap",
                  gap: "0.75rem",
                  marginBottom: "0.8rem",
                }}
              >
                <p
                  className={styles.card_subheading}
                  style={{
                    margin: 0,
                    flex: "1 1 220px",
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "normal",
                  }}
                >
                  Offset Credit Distribution by Type
                </p>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    flex: "1 1 360px",
                    minWidth: 0,
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      fontSize: "1rem",
                      margin: "0 0 1rem 0",
                      fontWeight: 800,
                      color: "#2f3338",
                    }}
                  >
                    {formatNumberCommaSeparated(selectedOffsetTotal)} tCO₂e
                    <span
                      className={styles.trend_up}
                      style={{
                        fontSize: "1rem",
                        fontWeight: 700,
                        color: selectedOffsetYoY.color,
                      }}
                    >
                      {" "}
                      {formatYoYText(selectedOffsetYoY)}
                    </span>
                  </p>
                  <p
                    className={styles.table_text}
                    style={{
                      margin: 0,
                      fontWeight: 600,
                      whiteSpace: "nowrap",
                      marginBottom: "10px",
                    }}
                  >
                    Filter by Type
                  </p>
                  <select
                    value={selectedOffsetType}
                    onChange={(e) => setSelectedOffsetType(e.target.value)}
                    style={{
                      padding: "4px 10px",
                      borderRadius: "4px",
                      border: "1px solid #d9d9d9",
                      width: "20%",
                      // maxWidth: "100%",
                      minWidth: 0,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      marginBottom: "10px",
                    }}
                  >
                    <option value="All">All</option>
                    {stationaryEmissionLabels.map((item) => (
                      <option key={item.label} value={item.label}>
                        {item.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              {filteredStationaryEmissionLabels?.length > 0 ? (
                <div
                  className={styles.stationary_chart_container}
                  style={{ alignItems: "flex-start" }}
                >
                  <Box sx={{ width: "52%" }}>
                    <EchartDoughnutChart
                      labels={filteredStationaryEmissionLabels?.map(
                        (el) => el?.label,
                      )}
                      dataPoints={filteredStationaryPieDataPoints}
                      colors={filteredStationaryEmissionLabels?.map(
                        (el) => el?.color,
                      )}
                      legendPosition="top"
                      customWidth={"100%"}
                      customHeight={"100%"}
                      hide={true}
                      showSliceLabels={false}
                      innerRadius="50%"
                      outerRadius="92%"
                      sliceGap={0}
                      sliceBorderWidth={8}
                    />
                  </Box>
                  <div
                    className={styles.doughnut_table_div}
                    style={{ width: "48%", marginTop: "0.4rem" }}
                  >
                    {filteredStationaryEmissionLabels.map((item, index) => (
                      <div key={index} className={styles.table_container}>
                        <div className={styles.table_row}>
                          <span
                            className={styles.table_row_label}
                            style={{
                              backgroundColor: item.color,
                            }}
                          ></span>
                          <span className={styles.table_text}>
                            {item.label}
                          </span>
                        </div>
                        <span className={styles.table_text}>
                          {formatNumberCommaSeparated(
                            fixedTons(item?.value ?? 0),
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <Box
                  sx={{
                    height: "250px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#d3d3d3",
                      fontWeight: "bold",
                      fontFamily: "inter",
                      fontSize: "24px",
                    }}
                  >
                    No Data Found
                  </Typography>
                </Box>
              )}
            </div>

            <div
              className={styles.doughnut_container}
              style={{ width: "100%", padding: "1.5rem" }}
            >
              <p
                className={styles.card_subheading}
                style={{ marginBottom: "1rem" }}
              >
                Credits Verification Status
              </p>
              {verificationStatuses.every(
                (s) => Number(carbonOffsettingData?.[s.key] || 0) === 0,
              ) ? (
                <Box
                  sx={{
                    height: "250px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#d3d3d3",
                      fontWeight: "bold",
                      fontFamily: "inter",
                      fontSize: "24px",
                    }}
                  >
                    No Data Found
                  </Typography>
                </Box>
              ) : (
                <div style={{ height: "300px" }}>
                  <Bar data={data} options={options} />
                </div>
              )}
            </div>
          </div>

          <div
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "1.5rem",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              marginTop: "2rem",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "1rem",
              }}
            >
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "160%",
                  letterSpacing: "0%",
                  color: "rgba(102, 102, 102, 0.8)",
                  margin: 0,
                  fontFamily: "Inter",
                }}
              >
                Vintage Year Distribution
              </p>
            </div>

            {vintageYearLabels.length === 0 ||
            vintageYearLabels.every(
              (_label, idx) => !vintageYearHasApiPoint[idx],
            ) ? (
              <Box
                sx={{
                  height: "250px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    textAlign: "center",
                    color: "#d3d3d3",
                    fontWeight: "bold",
                    fontFamily: "inter",
                    fontSize: "24px",
                  }}
                >
                  No Data Found
                </Typography>
              </Box>
            ) : (
              <div style={{ height: "300px" }}>
                <Bar data={data1} options={options1} />
              </div>
            )}
          </div>
        </div>
      </Unauthorized>
    </MainDashboardLayout>
  );
};

export default Dashboard;
